export default "__VITE_ASSET__DU$2Rcjg__"